<template>
  <v-dialog
    eager
    width="800"
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <v-row justify="space-around">
          <v-col cols="3" class="font-weight-bold">
            {{ this.$t('display/emergency:window.object') }}
          </v-col>
          <v-col cols="9">
            <div>{{ model.name }}</div>
            <div>{{ model.id }}</div>
            <div>{{ model.address }}</div>
            <div>{{ model.city }}</div>
            <div>{{ model.country }}</div>
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col cols="3" class="font-weight-bold">
            {{ this.$t('display/emergency:window.log') }}
          </v-col>
          <v-col cols="9" class="log-info">
            <div class="font-weight-bold">{{ this.$t('display/emergency:window.started-at') }}: {{ model.start }}  </div>

            <div class="comment">
              <div class="font-weight-bold"> {{ this.$t('common:comment_plural') }}: </div>
              <div v-for="comment in model.comments" :key="comment.id + ' - ' + comment.createdAt">
                {{ comment.createdAt }} : {{ comment.comment }}
              </div>
            </div>

            <div class="comment font-weight-bold">
              <div class="font-weight-bold"> {{ this.$t('common:answer_plural') }}: </div>
              <div v-for="answer in model.answers" :key="answer.id + ' - ' + answer.msgTime">
                {{ answer.msgTime }} : {{ answer.message }}
              </div>
            </div>

            <div class="mt-2 font-weight-bold">{{ this.$t('display/emergency:window.closed-at') }}: {{ model.stop }}  </div>
          </v-col>
        </v-row>

        <!-- Image Loading and Display -->
        <v-row justify="space-around" v-if="photos.length > 0">
          <v-col>
            <v-select
                :items="photos"
                item-text="name"
                item-value="id"
                :menu-props="{bottom: true, offsetY: true}"
                v-model="selectedPhoto"
                outlined
                clearable
                @change="loadPhoto"
                :label="$t('common:image_plural')"
            />
          </v-col>
        </v-row>
        <v-row justify="space-around" v-if="selectedPhoto">
          <v-col>
            <v-img
                :src="image"
                @click="openPhoto"
                class="pointer"
            />
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog=false"
        >
          {{ this.$t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import EmergencyService from '@/modules/display/services/emergency-service';
import Utils from '@/modules/core/services/utils';
import ElevatorService from "@/modules/display/services/elevator-service";

export default {
  name: "DetailWindow",
  data() {
    return {
      model: {},
      dialog: false,

      photos: [],
      selectedPhoto: null,
      image: null
    }
  },
  methods: {
    initialization(item) {
      //load basic emergency Log information
      EmergencyService.readFromAPI(
        item.id,
        (response) => {
          this.model = response.data;
          this.dialog = true;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/emergency:emergency-info')}));
        }
      );

      //load image data belonging to the emergency log
      this.photos = [];
      this.selectedPhoto = null;
      this.images = null;
      EmergencyService.readImageDataFromAPI(
          item.id,
          (response) => {
            this.photos = []
            response.data.forEach((photo) => {
              this.photos.push({
                id: photo[0],
                name: photo[1]
              });
            });
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/emergency:emergency-info')}));
          }
      );
    },

    loadPhoto() {
      this.image = null;
      if (this.selectedPhoto) {
        ElevatorService.loadSelectedImage(
            this.selectedPhoto,
            (response) => {
              this.image = 'data:image/jpeg;base64,' + response.data;
            },
            () => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:image')}));
            }
        );
      }
    },

    openPhoto() {
      var imageContainer = new Image();
      imageContainer.src = this.image;

      var newWindow = window.open("");
      newWindow.document.write(imageContainer.outerHTML);
    }
  }
}
</script>

<style lang="scss" scoped>
  .pointer {
    cursor: pointer;
  }
</style>
